import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('SummaryActivityController', ['$scope', '$rootScope', '$q', '$window', '$filter', '$timeout', '$location', '$stateParams', '$state', 'alerts', 'userService', 'leanLawApi', 'reportsService', 'exportJson', 'singleRequest', function ($scope, $rootScope, $q, $window, $filter, $timeout, $location, $stateParams, $state, alerts, userService, leanLawApi, reportsService, exportJson, singleRequest) {
  $scope.activities = [{}];

  // $scope.filter is owned by sidebar

  $scope.loading = true;

  //
  function load() {
    if ($scope.activeTab != 'activity') return;
    const query = queryFromFilter();
    if (!query) return;
    query.billed = 'any';
    query.billedState = undefined;
    $scope.loading = true;
    const entries = singleRequest.apiCall('tabdetail-entries').listEntries(query).then(list => {
      if (!list) return;
      return list.entries.map(e => ({
        date: e.startTime,
        description: e.description,
        amount: e.billingType === 'billable' ? calculateEntryAmount(e.rate.amount, e.hours) : 0,
        billed: e.billed,
        account: e.account,
        matter: e.matter,
        hours: e.hours
      }));
    });
    const expenses = singleRequest.apiCall('tabdetail-expenses').listExpenses(query).then(list => {
      if (!list) return;
      return list.expenses.map(e => ({
        date: e.date,
        description: e.description,
        amount: e.amount,
        billed: e.billed,
        account: e.account,
        matter: e.matter
      }));
    });
    $q.all([entries, expenses]).spread((entries, expenses) => {
      $scope.activities = [];
      if ($scope.cm.matter) {
        $scope.activities.push({
          description: 'Matter opened',
          date: new Date($scope.cm.matter.opened)
        });
      }
      $scope.activities = $scope.activities.concat(entries);
      $scope.activities = $scope.activities.concat(expenses);
      $scope.activities = $scope.activities.sort((a, b) => b.date - a.date);
    }).finally(() => {
      $scope.loading = false;
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    const query = reportsService.queryFromFilter($scope.filter);
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.export = function () {
    function yn(bool) {
      if (bool) return 'Yes';
      return 'No';
    }
    const exp = $scope.activities.map(a => ({
      Date: $filter('dateLogical')(a.date),
      Description: a.description,
      User: a.account ? a.account.name : '',
      Matter: a.matter ? a.matter.label || a.matter.name : '',
      Hours: $filter('hoursDecimal')(a.hours),
      Amount: $filter('amount')(a.amount),
      Billable: a.matter ? yn(a.billable) : '',
      Billed: a.matter ? yn(a.billed) : ''
    }));
    exportJson.downloadCsv(exp);
  };
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    load();
  });
  $scope.$on('report-sidebar-filterchange', (event, payload) => {
    load();
  });

  // Suffix is the active tab name for this view
  $scope.$on('summary-export-activity', payload => {
    $scope.export();
  });
  $scope.$watch('cm', newValue => {
    load();
  });
  $scope.$watch('activeTab', newValue => {
    $timeout(load);
  });
}]);